import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useDownloadCsvDoctorsApi, useFetchDoctorsApi } from 'api/doctor'
import { Doctor, DoctorSearchForm } from 'entities/doctor'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { doctorColumnInfoList, DoctorTableData } from './doctor_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { InputField } from 'components/shared/input'
import { useState } from 'react'
import { EditDoctorForm, NewDoctorForm } from './doctor_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const DoctorsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<DoctorSearchForm>()
    const preSearchForm = useForm<DoctorSearchForm>(params)
    const searchForm = useForm<DoctorSearchForm>(params)
    const api = useFetchDoctorsApi(searchForm)
    const downloadCsvApi = useDownloadCsvDoctorsApi(searchForm)
    const checkIdForm = useMultipleCheckForm<Doctor>()
    const doctorDisplaySetting = useDisplaySetting(doctorColumnInfoList(searchForm), 'Doctor')
    const [selectedDoctor, setSelectedDoctor] = useState<Doctor>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof DoctorSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`doctors?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (doctor: Doctor) => {
        setSelectedDoctor(doctor)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    return (
        <>
            <EditDoctorForm
                doctor={selectedDoctor}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="医者"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewDoctorForm
                            onComplete={() => {
                                api.execute()
                            }}
                            institutionId={params.institutionId}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <InputField
                        attr="name"
                        form={preSearchForm}
                        placeholder="名前で検索"
                        onPressEnter={() => {
                            searchForm.updateObject('name', preSearchForm.getValue('name'))
                        }}
                        style={{ marginBottom: 0, width: 250 }}
                    />
                </Flex>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={checkIdForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={checkIdForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={doctorDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={doctorDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((doctor: Doctor) => {
                                return (
                                    <CheckboxTableRow
                                        key={`doctor-${doctor.id}`}
                                        item={doctor}
                                        multipleCheckForm={checkIdForm}
                                        onClickEdit={() => handleClickEdit(doctor)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedDoctor(doctor)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <DoctorTableData doctor={doctor} displaySetting={doctorDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Doctor"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(DoctorsPage)
